import { NgClass, NgIf } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-table-filter-item',
  template: `
    <div class="flex flex-col ml-4 table-filter-item" [ngClass]="containerClass">
      <span class="table-filter-item-label" *ngIf="label">{{ label }}</span>
      <div><ng-content></ng-content></div>
    </div>
  `,
  styles: [
    `
      .table-filter-item-label {
        font-size: 12px;
        font-weight: 600;
      }
    `,
  ],
  standalone: true,
  imports: [NgClass, NgIf],
})
export class TableFilterItemComponent {
  @Input() label = '';
  @Input() containerClass: string;
  @Input() fill: boolean | '' = false;

  @HostBinding('class.flex-1') get fillWithSpace() {
    return this.fill !== false;
  }
}
